import { downloadBlobAsFile } from './DownLoadBlobAsFile';

/**
 * Handles downloading the Master Pool dataset file.
 * @param authenticationContext - Auth context to access API.
 * @param masterPoolCmhcAccountNumber - CMHC number to query the dataset.
 * @param getMasterpoolsDataSet - Function to get dataset blob.
 * @param onComplete - Optional callback on completion.
 */
export const handleMasterPoolDownload = async ({
  authenticationContext,
  masterPoolCmhcAccountNumber,
  fileName,
  getMasterpoolsDataSet,
  onComplete
}: {
  authenticationContext: any;
  masterPoolCmhcAccountNumber?: string;
  fileName: string;
  getMasterpoolsDataSet: (auth: any, number: string) => Promise<Blob | null>;
  onComplete?: () => void;
}) => {
  if (!masterPoolCmhcAccountNumber) return;

  try {
    const blob = await getMasterpoolsDataSet(authenticationContext, masterPoolCmhcAccountNumber);

    if (blob instanceof Blob) {
      downloadBlobAsFile(blob, fileName);
    } else {
      console.warn('No data returned from dataset API');
    }
  } catch (err) {
    console.error('Error downloading file:', err);
  } finally {
    onComplete?.();
  }
};
